var external_links_open_new_window = "true";
var mark_special_links = "true";
//var setupTabs = null;
//var clickFirstTab = null;
